import Navbar from "../components/navbar/Navbar";
import OrderList from "../components/orders/OrderList";
import Banner from "../components/banner/Banner";
import ProfileSideBar from "../components/profile/ProfileSideBar";
import { useEffect } from "react";

const Orders = () => {
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <div>
            <Navbar />
            <Banner title="Orders" />
            <div className="bg-imagea">
                <section className="ftco-section contact-section">
                    <div className="container mt-5 text-left">
                        <div className="row block-9">
                            <div className="col-md-3 contact-info ">
                                <ProfileSideBar />
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-8 ">
                                <OrderList />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default Orders;